import React from 'react';

import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';

//Sentiment icons
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@material-ui/icons/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';

const ratingsAndIcons = {
  1: {
    icon: <SentimentVeryDissatisfiedIcon style={{fontSize:'40px', color:'#e41b23'}} />,
    label: 'Very unhopeful',
  },
  2: {
    icon: <SentimentDissatisfiedIcon style={{fontSize:'40px', color:'#f29b27'}}  />,
    label: 'Unhopeful',
  },
  3: {
    icon: <SentimentSatisfiedIcon style={{fontSize:'40px', color:'#ffd800'}}  />,
    label: 'Neutral',
  },
  4: {
    icon: <SentimentSatisfiedAltIcon style={{fontSize:'40px', color:'#b9cf39'}}  />,
    label: 'Hopeful',
  },
  5: {
    icon: <SentimentVerySatisfiedIcon style={{fontSize:'40px', color:'#35af48'}}  />,
    label: 'Very Hopeful',
  },
};

/**
 * Display to auxiliary stability questions
 * @param {*} props 
 * @author BrianCastor
 */
export default function StabilizeSituationQuestions(props) {
  function handleInputChange(field, newValue) {
    let newData = {};
    newData[field] = newValue;
    props.updateUserData(newData);
  }

  return (
    <div style={{ padding: '0px 10px 10px 10px' }}>
      <h3>Connect Hope</h3>
      <Grid container spacing={2}>
        <Grid item xs={12}>
        <TextField 
          required
          label="What service would help stabilize your situation now?"
          variant="outlined"
          fullWidth
          defaultValue=""
          /*InputLabelProps={{
            shrink: true,
          }}*/
          multiline
          rows={3}
          value={props.userData['Most_helpful_to_stability_situation__c'] || ''}
          onChange={(event) => handleInputChange('Most_helpful_to_stability_situation__c', event.target.value)}/>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
        <p style={{fontSize:'15px'}}>How hopeful are you that you will stabilize your situation?</p>
        <RadioGroup row aria-label="position" name="position">
        <Grid container justify="center">
          {Object.keys(ratingsAndIcons).map((ratingNumber, index) => {
            return (
              <Grid item key={index}>
                <FormControlLabel
                  checked={props.userData['Hope_Rating__c'] === ratingNumber}
                  control={<Radio color="primary" />}
                  label={ratingsAndIcons[ratingNumber].icon}
                  labelPlacement="top"
                  onChange={() => handleInputChange('Hope_Rating__c', ratingNumber)}
                />
              </Grid>
            )
          })}
          </Grid>
        </RadioGroup>
        </Grid>
      </Grid>
    </div>
  );
}